import React from 'react';
import { Button, Modal } from 'antd';

/**
 * Done, when the person changed the date range or the filter while arranging
 * (the second review's F3): saving them as the dashboard's defaults changes
 * what it opens with, so it is asked, never assumed — a person who only moved
 * a tile keeps the view they had open.
 *
 * The question names who it is for (the third review's N3). On a dashboard
 * for everyone (`forEveryone`), the default is what everyone sees:
 *
 *   Save for everyone        the layout and the changed controls, in one save
 *   Keep for this view only  the layout alone; the controls stay in the link
 *
 * On a personal one nobody else opens it, so the window never says
 * "everyone": Save as default / Keep for this view only, the same two saves.
 *
 * Closing the window keeps arranging, the draft as it was.
 */
export default function SaveControlsModal({ open, forEveryone = false, saving = false, onSave, onKeepForView, onClose }) {
	return (
		<Modal
			open={open}
			title={forEveryone ? 'Save the date range and filter for everyone?' : 'Save the date range and filter for this dashboard?'}
			onCancel={onClose}
			className='save-controls-modal'
			footer={[
				<Button key='view' onClick={onKeepForView} disabled={saving}>Keep for this view only</Button>,
				<Button key='save' type='primary' autoFocus loading={saving} onClick={onSave}>{forEveryone ? 'Save for everyone' : 'Save as default'}</Button>,
			]}
		>
			<p>
				{forEveryone
					? 'You changed the date range or the filter while arranging. Everyone who opens this dashboard without a link of their own sees what is saved.'
					: 'You changed the date range or the filter while arranging. Saved as the default, they are what this dashboard opens with; kept for this view, they stay in this link only.'}
			</p>
		</Modal>
	);
}
